import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { MenuSectionItem } from '@shared/interfaces/menu-config.interface';

@Component({
  selector: 'app-management-card',
  templateUrl: './management-card.component.html',
  styleUrls: ['./management-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManagementCardComponent extends ComponentAbstract implements OnInit {
  @Input() sectionItem: MenuSectionItem;

  constructor(protected cdr: ChangeDetectorRef, private router: Router) {
    super(cdr);
  }

  ngOnInit(): void {}

  openSubmenu() {
    if (this.sectionItem.urlPath) {
      this.router
        .navigate([this.sectionItem.urlPath], {
          queryParamsHandling: 'merge',
        })
        .then();
    }
  }
}
